import { Component, NgModule, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { GuestsService } from './../../services/GuestsService';

import { LanguageService } from './../../services/LanguageService';
import { LanguageConstants } from './../../common/language/LanguageConstants';

import * as _ from 'lodash';
//import Ps from 'perfect-scrollbar';
import {AuthServiceGuest} from "../../services/AuthServiceGuest";
import {CurrentUser} from "../../dataTypes/CurrentUser";
import { Subscription } from 'rxjs';
import { MobileStatusService } from '../../services/MobileStatusService';

@Component({
    selector: 'guests-component',
    templateUrl: './GuestsComponent.html',
})
export class GuestsComponent implements OnDestroy{

  public language = 'en';
  public languageConstants = LanguageConstants['en'];
  public rtl = false;
  public _user: CurrentUser;

  public activeTab: number;

  public search: string;

  private mobileStatusSubscription: Subscription;
  public isMobileFlag: boolean = false;
  public showNavMenu: boolean;


  constructor(public _router: Router,
    private _language: LanguageService,
    private _GuestsService: GuestsService,
    private _AuthService: AuthServiceGuest,
    private mobileStatusService: MobileStatusService) {
      this._AuthService.userModel$.subscribe(userModel => {
        this._user = userModel;
       // this.activeTab = (this.user.visibiltyPermissions === 0 || this.user.visibiltyPermissions === 1 ? 0 : 1);
      });

      this._language.language$.subscribe(
          language => {
              this.language = language;
              this.languageConstants = LanguageConstants[this.language];
          });
      this._language.rtl$.subscribe(
          rtl => {
              this.rtl = rtl;
          });

      _language.setLanguage('he');

    //-----------
    /////\\\\\\this.isMobile = window.innerWidth < 768;
    this.showNavMenu = !this.isMobileFlag;
    //--------------
      this.mobileStatusSubscription = this.mobileStatusService.isMobile$.subscribe(
        (isMobile) => {
          this.isMobileFlag = isMobile;
          // Do something when isMobile changes
          this.showNavMenu = !this.isMobileFlag;

        }
      );
  }
    
  ngOnInit(): void {

    const self = this;


    self._user = self._AuthService.getUserInfo();

    if (self._user) {

      if (self._user.visibiltyPermissions === 1 || self._user.visibiltyPermissions === 0) {
        self._router.navigateByUrl('/guest');
      }
      else if (self._user.visibiltyPermissions === 2 || self._user.visibiltyPermissions === 0) {
        self._router.navigateByUrl('/subscriber');
      }

    }
    
  }

  setActiveTab(tab): void {
      this.activeTab = tab;
  }
  

  logout(event: any): void {
    event.preventDefault();
    this._AuthService.logout();
  }

  ngOnDestroy() {
    this.mobileStatusSubscription.unsubscribe();
  }

}
